module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GdiftV/Images/cover.jpg?1703000975861",
      "alt": "This image is the cover for the book Good Housekeeping Cookbook: Sunday Dinner"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Good Housekeeping Cookbook: Sunday Dinner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the test kitchen of America’s iconic lifestyle magazine, recipes and meal plans to bring your family together for mealtime—includes photos")]), _vm._v("."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Make Sunday family dinner day! If you long to bring back the tradition of a weekly sit-down supper, you'll find everything you need to create wonderful meals and memories in this classic cookbook. It contains a full year's worth of triple-tested, family-friendly menus, plus 1,275 recipes for every occasion or any weeknight. From Brisket with Chunky Barbecue Sauce and Grilled Sweet Potatoes to Roast Chicken with Forty Cloves of Garlic and Buttermilk Biscuits, these dishes will make everybody at the table happy. Plus you'll find plenty of ideas—from shopping with your tween to teaching your child to fold decorative napkins—that will make Sunday dinner extra special for everyone.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Westmoreland\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Good Housekeeping magazine is an American icon of consumer protection and quality assurance. Each issue reaches 24 million readers and, with 15 editions published worldwide, it is an internationally recognized brand.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Hearst Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0